export default __webpack_public_path__ + "static/media/DNo.30-1.91d5a7af.jpg";